import type { TranslationKeys } from "./en"

export const zh: TranslationKeys = {
  // App
  appName: "DevPulse",

  // Navigation
  navDashboard: "仪表板",
  navContributors: "贡献者",
  navTeams: "团队",
  navRepositories: "代码库",

  // Views
  viewOrganization: "组织",
  viewGroup: "小组",
  viewIndividual: "个人",
  viewSelectPlaceholder: "选择视图",

  // Common
  loading: "正在加载数据...",
  authenticating: "正在验证...",
  loadingError: "数据加载错误",
  authError: "身份验证错误",
  retry: "重试",
  tryAgain: "再试一次",
  profile: "个人资料",
  settings: "设置",
  logout: "退出登录",
  selectTimeRange: "选择时间范围",
  selectTeam: "选择团队...",
  selectDeveloper: "选择开发者...",

  // Time ranges
  timeLast7Days: "最近7天",
  timeLast30Days: "最近30天",
  timeAll: "全部",

  // Dashboard titles
  dashboardOrganizationTitle: "组织仪表板",
  dashboardOrganizationSubtitle: "所有存储库和团队成员的开发指标概览",
  dashboardTeamTitle: "团队仪表板",
  dashboardTeamSubtitle: "{team}团队成员的开发指标",
  dashboardTeamNoData: "未配置团队。请添加团队数据以查看特定团队指标。",
  dashboardIndividualTitle: "个人仪表板",
  dashboardIndividualSubtitle: "{author}的开发指标",
  dashboardIndividualNoData: "未找到作者。请加载数据以查看个人指标。",

  // Contributors page
  contributorsTitle: "贡献者",
  contributorsSubtitle: "分析贡献者的表现和活动",
  contributorsNoData: "所选时间范围内没有可用的贡献者数据。",

  // Teams page
  teamsTitle: "团队",
  teamsSubtitle: "分析团队的表现和活动",
  teamsNoData: "所选时间范围内没有可用的团队数据。",

  // Repositories page
  repositoriesTitle: "代码库",
  repositoriesSubtitle: "分析代码库的表现和活动",
  repositoriesNoData: "所选时间范围内没有可用的代码库数据。",
  repositoriesScoreTitle: "代码库提交复杂度评分",
  repositoriesScoreDescription: "每个代码库所有提交的总复杂度评分。",
  repositoriesPRsTitle: "代码库拉取请求",
  repositoriesPRsDescription: "每个代码库已合并的拉取请求数量。",

  // DORA Metrics page
  doraMetricsTitle: "DORA指标",
  doraMetricsSubtitle: "用于衡量软件交付绩效的DevOps研究与评估(DORA)指标",
  doraNoDataTitle: "无可用的DORA指标数据",
  doraNoDataDescription: "DORA指标需要发布、拉取请求和提交数据。请确保已收集和导出数据。",
  doraMissingDataTitle: "完整DORA指标所需的缺失数据",
  doraMissingDataDescription: "以下数据点缺失或不完整，无法进行完整的DORA指标计算：",
  doraDataLimitationsTitle: "数据限制",
  doraDataLimitationsDescription: "显示的DORA指标是根据可用数据计算的，存在一些限制：",
  doraOverallPerformance: "总体DORA性能水平",
  doraOverallDescription: "根据四个关键指标，按照DORA基准计算您团队的总体性能水平。",
  doraDeploymentFrequency: "部署频率",
  doraLeadTime: "变更前置时间",
  doraChangeFailureRate: "变更失败率",
  doraTimeToRestore: "服务恢复时间",
  doraPerMonth: "每月",
  doraDays: "天",
  doraHours: "小时",
  doraDeploymentsByMonth: "每月部署次数",
  doraLeadTimeTrend: "前置时间趋势",
  doraFailureRateTrend: "失败率趋势",
  doraRestoreTimeTrend: "恢复时间趋势",
  doraDeploymentFrequencyDetail: "部署频率随时间变化",
  doraDeploymentFrequencyDetailDescription: "每月部署次数",
  doraLeadTimeDetail: "变更前置时间随时间变化",
  doraLeadTimeDetailDescription: "从PR创建到合并的平均时间（小时）每月",
  doraMethodologyTitle: "方法论和数据来源",
  doraDeploymentFrequencyMethodology:
    "从发布数据库表中的已发布版本（不包括草稿和预发布版本）计算。",
  doraLeadTimeMethodology: "计算为拉取请求创建和合并之间的时间，从pull_requests表测量。",
  doraChangeFailureRateMethodology:
    "通过检测发布后7天内的错误修复或回滚提交来估计。这是一个近似值，因为我们没有明确的部署失败跟踪。",
  doraTimeToRestoreMethodology:
    "估计为发布和第一次错误修复/回滚提交之间的时间。这是一个近似值，因为我们没有事件管理数据。",

  // DORA Performance Levels
  doraLevelElite: "精英",
  doraLevelHigh: "高",
  doraLevelMedium: "中等",
  doraLevelLow: "低",

  // DORA Missing Data Points
  doraMissingReleases: "部署频率的发布数据",
  doraMissingPullRequests: "交付时间计算的拉取请求数据",
  doraMissingCommits: "故障分析的提交数据",
  doraMissingDeployments: "部署数据（阶段2）- 使用发布作为代理",
  doraMissingWorkflowRuns: "CI/CD工作流数据（阶段2）- 管道可见性有限",
  doraMissingIncidents: "事件跟踪数据（阶段3）- 使用错误修复提交作为代理",

  error: "错误",

  // Tabs
  tabPerformance: "性能",
  tabScore: "评分",
  tabPRs: "拉取请求",
  tabIssues: "问题",
  tabActivity: "活动",
  tabReleases: "发布",

  // Activity
  recentActivity: "最近活动",

  // Releases tab
  releasesTitle: "发布（最近12周）",
  releasesDescription: "所有代码库中发布的版本总数",
  releasesChartTitle: "按代码库的发布（最近6周）",
  releasesChartDescription: "每个代码库的每周发布活动",

  // Performance tab
  performanceScoreTitle: "综合性能评分（0-100）",
  performanceScoreDescription:
    "综合指标，结合了代码质量（30%）、交付吞吐量（25%）、代码影响（20%）、问题解决（15%）和工作多样性（10%）。",
  performanceScoreAverage: "平均值：{value}",
  performanceScoreComparison: " — 百分比显示每个贡献者与此平均值的比较。",

  performanceScoreTeamTitle: "团队综合性能评分（0-100）",
  performanceScoreTeamDescription:
    "汇总的性能评分，结合所有团队成员在代码质量、交付吞吐量、代码影响、问题解决和工作多样性方面的贡献。",

  // Score tab
  scoreTitle: "提交复杂度评分",
  scoreDescription:
    "根据更改的文件、修改的行数、函数更改和圈复杂度来衡量代码复杂度。较高的分数表示更具挑战性和影响力的贡献。",
  scoreAverage: "平均值：{value}分",
  scoreComparison: " — 百分比显示每个贡献者与此平均值的比较。",

  scoreTeamTitle: "团队提交复杂度评分",
  scoreTeamDescription:
    "所有团队成员提交的综合复杂度评分，衡量代码更改的技术挑战和影响。较高的分数表示更复杂和更有影响力的工作。",

  // PRs tab
  prsTitle: "已合并的拉取请求",
  prsDescription:
    "成功合并的拉取请求总数。此指标反映了代码审查参与度、协作和功能及修复的成功交付。",
  prsAverage: "平均值：{value}个拉取请求",
  prsComparison: " — 百分比显示每个贡献者与此平均值的比较。",

  prsTeamTitle: "团队已合并的拉取请求",
  prsTeamDescription:
    "所有团队成员合并的拉取请求总数。这反映了团队协作、代码审查参与度和功能及修复的成功交付。",

  // Performance tab - Insight cards
  insightMergedPRs: "已合并的拉取请求",
  insightPRThroughput: "拉取请求吞吐量",
  insightFeatureCommits: "功能提交",
  insightFeatures: "功能",
  insightBugfixCommits: "修复提交",
  insightBugfixes: "修复",
  insightMaintenanceCommits: "维护提交",
  insightMaintenance: "维护",

  // Chart titles
  chartCommitsByClassification: "按分类统计的提交",
  chartCommitsBySize: "按大小统计的提交",
  chartCommitScoresByWeek: "每周提交评分",
  chartCommitScoresByWeekDesc: "按周分组并按大小堆叠的提交复杂度总分",
  chartCommitScoresByClassificationWeek: "按分类的每周提交评分",
  chartCommitScoresByClassificationWeekDesc: "按周分组并按分类堆叠的提交复杂度总分",
  chartPRsMerged: "本月合并的拉取请求",
  chartPRsMergedByWeek: "每周合并的拉取请求",
  chartPRsMergedByWeekDesc: "最近6周每周合并的拉取请求数量",
  chartCodeChanges: "代码更改",
  chartCodeChangesByWeek: "每周代码更改",
  chartCodeChangesByWeekDesc: "每周合并的拉取请求中添加和删除的代码行数",
  chartIssuesCreated: "本月创建的问题",
  chartIssuesClosed: "本月关闭的问题",
  chartActivityTitle: "贡献活动",
  chartActivityDescription: "过去一年内组织范围的活动，包括提交、拉取请求和问题",
  chartDetails: "详情",

  // Chart labels
  linesAdded: "添加的行数",
  linesRemoved: "删除的行数",

  // Language selector
  languageLabel: "语言",
  languageEnglish: "English",
  languageGerman: "Deutsch",
  languageSpanish: "Español",
  languageChinese: "中文",

  // DataTable
  dataTableFilters: "筛选器",
  dataTableFilterBy: "筛选条件：",
  dataTableNoResults: "无结果。",
  dataTableRowsPerPage: "每页行数：",
  dataTablePage: "第",
  dataTableOf: "页，共",
  dataTableTotalRows: "行",
  dataTableSearch: "搜索...",

  // Charts
  chartTrend: "趋势",
  chartDistribution: "分布",
  chartDate: "日期",

  // Quick insights
  quickInsightDate: "最近7天",
  quickInsightVsLastWeek: "对比上周 {count}",
  quickInsightVsLastMonth: "对比上月 {count}",

  // Data table column headers
  tableColumnTitle: "标题",
  tableColumnMessage: "消息",
  tableColumnAuthor: "作者",
  tableColumnDate: "日期",
  tableColumnCreated: "创建时间",
  tableColumnScore: "评分",
  tableColumnFiles: "文件",
  tableColumnAdditions: "+",
  tableColumnDeletions: "-",

  // Chart descriptions
  chartCommitsByClassificationDesc: "按分类（提交类型）分组并按复杂度大小堆叠的提交数量",
  chartCommitsBySizeDesc: "按复杂度大小分组并按分类（提交类型）堆叠的提交数量",
  chartCodeChangesDesc: "合并的拉取请求中添加和删除的代码行数",
  chartPRsMergedDesc: "合并了 {count} 个PR（对比上月 {prevCount} 个）",
  chartIssuesCreatedDesc: "创建了 {count} 个问题（对比上月 {prevCount} 个）",
  chartIssuesClosedDesc: "关闭了 {count} 个问题（对比上月 {prevCount} 个）",
}
